import { baseURL } from '..';
import { IProject } from '../../shared/iProject';
import { IResult } from '../../shared/iResult';
import httpClient, { IResponse } from '../httpClient';
import { createHeaders, createRequest } from '../util';

const calculationProvider = () => {
    const getAllCalculatedScenariosAsync = async (payload: IProject): Promise<IResponse<IResult>> =>
        httpClient.postAsync(createRequest(baseURL, '/Calculation/GetAllCalculatedScenarios', undefined, payload), createHeaders());

    return { getAllCalculatedScenariosAsync };
};

export default calculationProvider();
